<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="ibox tabs-ibox">
                <div class="ibox-content">
                    <div class="tabs-grey">
                        <ul class="nav nav-tabs" role="tablist">
                            <li>
                                <a href="#" class="nav-link" :class="{'active': activeTab == 'choosing_position' }" @click="setActive('choosing_position')">
                                    {{ __('choosing_position') }}
                                </a>
                            </li>
                            <li>
                                <a href="#" class="nav-link" @click="setActive('analyze')" :class="{'active': activeTab == 'analyze' }">
                                    {{ __('analyze') }}
                                </a>
                            </li>
                            <li>
                                <a href="#" class="nav-link" @click="setActive('chart')" :class="{'active': activeTab == 'chart' }">
                                    {{ __('chart') }}
                                </a>
                            </li>
                        </ul>
                        <list-position-component
                        v-if="activeTab == 'choosing_position'"
                        :analyze-type="analyzeType"
                        :columns-selected="columnsSelected"
                        :columns-not-selected="columnsNotSelected"
                        :table-sort="tableSort"
                        :documents="documents"
                        :access="access"
                        @toggle-all="handleToggleAll"
                        @showModal="showModal()"
                        ></list-position-component>
                        <grouped-and-sorted-documents
                        v-if="activeTab == 'analyze'"
                        :analyze-type="analyzeType"
                        :analyze-level="analyzeLevel"
                        :show-analyze-groups="showAnalyzeGroups"
                        :analyze-criteria-status="analyzeCriteriaStatus"
                        :groupedAndSortedDocumentItems="groupedAndSortedDocumentItems"
                        :columns-selected="groupedColumnsSelected"
                        @showModal="$emit('showGroupedModal')">
                        </grouped-and-sorted-documents>
                        <analyze-chart
                        v-if="activeTab == 'chart'"
                        :chart-data="chartData"
                        :analyze-level="analyzeLevel"
                        :analyzeType="analyzeType"
                        :documents="documents"
                        :currency="currency">

                        </analyze-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AnalyzeTabComponent",
    data: function () {
        return {
            activeTab : this.active_tab
        }
    },
    props: {
        chartData:{
            type:Object
        },
        analyzeType: {
            type: String
        },
        columnsSelected:{
            type: Array
        },
        columnsNotSelected:{
            type: Array
        },
        // zakladka "Analiza" ma wlasny uklad kolumn (nie dziedziczy z "Wybor pozycji")
        groupedColumnsSelected:{
            type: Array
        },
        tableSort:{
            type: Object,
            default: null
        },
        documents:{
            type:Array,
        },
        active_tab:{
            type: String
        },
        groupedAndSortedDocumentItems:{
            type:Object
        },
        analyzeLevel:{
            type:Object
        },
        showAnalyzeGroups:{
            type:Boolean,
        },
        analyzeCriteriaStatus:{
            type: Object
        },
        currency:{
            type:String
        },
        access:{
            type: Object
        }
    },
    methods:{
        setActive(tab){
            this.activeTab = tab;
            this.$emit('setActiveTab', tab);
        },
        showModal(){
            this.$emit('showModal');
        },
        handleToggleAll(isChecked) {
            this.$emit('toggle-all', isChecked);
        }
    }
}
</script>

<style>

</style>
